import { FC } from 'react';

import { EmptySearchList } from '../../../../components/empty-search-list/index';
import { ShareClass } from '../../../../hooks/index';
import { Column } from '../../../../types/snapshot.types';
import { TableProps } from '../details';
import { EmptyDetails } from '../empty-details';
import { snapshotViewBy } from '../snapshot-view-by/index';
import { getShareClasses } from '../snapshot-view-by/snapshot-view-by.types';
import { getCapTableViewByMode } from './cap-table-sticky-classes';
import { BasicTable } from './table-basic';

export const Table: FC<TableProps> = ({
  viewBy,
  visibleColumns,
  type,
  search,
  isEmptySearchResult,
  ordering,
  setEmptySearchResult,
  snapshot,
}) => {
  const isSnapshotStatsExist = snapshot?.stats && snapshot?.stats?.stakeholders?.length > 0;
  const { shareClass } = ShareClass.useDefaultShareClass();

  if (!snapshot || !isSnapshotStatsExist) return <EmptyDetails />;

  if (isEmptySearchResult) return <EmptySearchList className="m-auto my-20" />;

  const selectedViewBy = getCapTableViewByMode(viewBy);

  const defaultShareClassId = shareClass?.id || '';

  const { otherShareClasses } = getShareClasses(defaultShareClassId, snapshot.stats.shareClasses);

  return (
    <>
      <BasicTable
        additionalColumns={{
          [Column.OTHER_SHARE_CLASSES]: otherShareClasses
            .filter(({ diluted }) => diluted)
            .map(({ name }) => (name.length > 30 ? name.substring(0, 30) + '...' : name))
            .sort((a, b) => a.localeCompare(b)),
        }}
        sortBy={type}
        viewBy={viewBy}
        visibleColumns={visibleColumns}
      >
        {snapshotViewBy[selectedViewBy]({
          ordering,
          snapshot,
          viewBy,
          visibleColumns,
          type,
          search,
          setEmptySearchResult,
          possibleShareClasses: otherShareClasses
            .filter(({ diluted }) => diluted)
            .map(({ name }) => name)
            .sort((a, b) => a.localeCompare(b)),
        })}
      </BasicTable>
    </>
  );
};
